import { render, staticRenderFns } from "./FacilityInfo.vue?vue&type=template&id=ff81ac7c&scoped=true"
import script from "./FacilityInfo.vue?vue&type=script&lang=ts"
export * from "./FacilityInfo.vue?vue&type=script&lang=ts"
import style0 from "./FacilityInfo.vue?vue&type=style&index=0&id=ff81ac7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff81ac7c",
  null
  
)

export default component.exports